import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { X } from 'lucide-react';
import { toast } from 'sonner';

const RequestDemoModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    interest: 'Security & Surveillance',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    toast.success('Thanks — we\'ll get back to you shortly.');
    setIsSubmitting(false);
    setFormData({
      name: '',
      company: '',
      email: '',
      phone: '',
      interest: 'Security & Surveillance',
      message: ''
    });
    onClose();
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px] bg-[var(--bg-card)] border-[var(--border-light)]">
        <DialogHeader>
          <DialogTitle className="text-2xl font-semibold text-[var(--text-primary)]">
            Request a Demo
          </DialogTitle>
          <DialogDescription className="text-[var(--text-secondary)]">
            Tell us what you're trying to achieve. We'll recommend the right deployment model.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 mt-4">
          <div>
            <label className="block text-sm font-medium text-[var(--text-body)] mb-1">Name *</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full px-3 py-2 border border-[var(--border-light)] rounded-lg bg-[var(--bg-page)] text-[var(--text-body)] focus:outline-none focus:ring-2 focus:ring-[var(--accent-primary)] transition-all"
              placeholder="Your name"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-[var(--text-body)] mb-1">Company *</label>
            <input
              type="text"
              name="company"
              value={formData.company}
              onChange={handleChange}
              required
              className="w-full px-3 py-2 border border-[var(--border-light)] rounded-lg bg-[var(--bg-page)] text-[var(--text-body)] focus:outline-none focus:ring-2 focus:ring-[var(--accent-primary)] transition-all"
              placeholder="Company name"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-[var(--text-body)] mb-1">Email *</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full px-3 py-2 border border-[var(--border-light)] rounded-lg bg-[var(--bg-page)] text-[var(--text-body)] focus:outline-none focus:ring-2 focus:ring-[var(--accent-primary)] transition-all"
              placeholder="your@email.com"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-[var(--text-body)] mb-1">Phone (optional)</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-[var(--border-light)] rounded-lg bg-[var(--bg-page)] text-[var(--text-body)] focus:outline-none focus:ring-2 focus:ring-[var(--accent-primary)] transition-all"
              placeholder="+61"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-[var(--text-body)] mb-1">Area of Interest *</label>
            <select
              name="interest"
              value={formData.interest}
              onChange={handleChange}
              required
              className="w-full px-3 py-2 border border-[var(--border-light)] rounded-lg bg-[var(--bg-page)] text-[var(--text-body)] focus:outline-none focus:ring-2 focus:ring-[var(--accent-primary)] transition-all"
            >
              <option>Security & Surveillance</option>
              <option>Industry 4.0</option>
              <option>Agriculture</option>
              <option>Partnership</option>
              <option>Other</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-[var(--text-body)] mb-1">Message</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows="3"
              className="w-full px-3 py-2 border border-[var(--border-light)] rounded-lg bg-[var(--bg-page)] text-[var(--text-body)] focus:outline-none focus:ring-2 focus:ring-[var(--accent-primary)] transition-all resize-none"
              placeholder="Tell us about your environment..."
            />
          </div>
          <p className="text-xs text-[var(--text-muted)]">
            By submitting this form, you agree to be contacted by Ferntree about your enquiry.
          </p>
          <button
            type="submit"
            disabled={isSubmitting}
            className="btn-primary w-full"
          >
            {isSubmitting ? 'Sending...' : 'Send Request'}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default RequestDemoModal;